import shouldForwardProp from '@styled-system/should-forward-prop';
import styled, { css } from 'styled-components';

import type { Space } from '../../../theme/space';

type Alignment = 'center' | 'start';

export type Props = Readonly<{
  gap: Space;
  regular?: boolean;
  align?: Alignment;
}>;

const columnsAlignment = ({ align }: Props) => css`
  align-items: ${align};
`

const Columns = styled.div.withConfig({
  shouldForwardProp: (prop) => shouldForwardProp(prop),
})<Props>`
  display: grid;
  gap: ${({ gap, theme }) => theme.scTheme.space[gap]};
  grid-auto-columns: ${({ regular = false }) => (regular ? '1fr' : 'max-content')};
  grid-auto-flow: column;
  grid-template-rows: 1fr;
  width: 100%;
  ${columnsAlignment}
`;

export default Columns;
